<div class="innerpage-fullwithbanner clearfix" *ngIf="analyzeId!=undefined && analyzeId!=0">
    <div class="left">
        <h2 class="bighead">Analysis</h2>
        <ul class="bread-crumbs">
            <li><a href="#" [routerLink]="prevPageRouteLink">1031 Trade<span>|</span></a></li>
            <li>Analysis</li>
        </ul>
    </div>
</div>
<div class="col-md-12" *ngIf="showNodata && isFromViewPage">
    <div class="border-div" >
        <div class="nodata" >
            <i class="icofont icofont-warning icon"></i>
            <p>Analytics cannot be shown for a single property</p>            
        </div>
        </div>
    </div>

        <div class="comparisonpage section-margin" *ngIf="!showNodata || !isFromViewPage">
            <div class="container  analysis-wrap  min-heightcontainer">
                <div class="border-div be-white-box" style="background:#fff;">
                    <div class="headings clearfix">
                        <h3 *ngIf="!isPropertyAnalysis" class="bleckhead">Portfolio Analysis</h3>
                        <h3 *ngIf="isPropertyAnalysis" class="bleckhead">Property Analysis</h3>
                        <div class="right" *ngIf="analyzeId==0">
                            <button class="btn btn-sm btn-border" (click)="analyze(true)">Analyze</button>
                            <button *ngIf="!comparePropertiesModel.IsOfferPortfolio" [disabled]="disableAdd" class="btn btn-circle btn-green" tooltip="Add Property" (click)="openModalForAddProperty(template,'commonmodal addPropertyAnalyze')" placement="top">
                                <i class="icofont icofont-plus icon"></i>
                            </button>
                        </div>
                    </div>

                    <div class="pos-relative margin-bottom-40">
                        <div class="table-responsive  fixedcolumn-table PropertyComparison-table" [ngClass]="{'without-rightfixedcolumn':(isPropertyAnalysis)}">
                            <table class="table basictable noborder ">
                                <tbody>
                                    <tr>
                                        <td class="thstyle padding0 fixedtd" style="width:150px;">
                                            <table class="table ">
                                                <tbody>
                                                    <tr>
                                                        <td class="thstyle firsttd">Tenants</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="thstyle">Asking Price</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="thstyle">Rent / NOI</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="thstyle">Credit Rating</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="thstyle">Cap Rate</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="thstyle">Return During Lease</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="thstyle">Rent Escalations</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="thstyle">Remaining Term</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="thstyle">Building Size(Sq Ft)</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="thstyle">Land(Acr)</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="thstyle">Year Built</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="thstyle">Lease Structure</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="thstyle">Ownership Type</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                        <td class="padding0 tdwidth" *ngFor="let item of comparePropertyDetailModelList">
                                            <table class="table ">
                                                <tbody>
                                                    <tr>
                                                        <td style="vertical-align:top" class="firsttd">
                                                            <div class="propertycheckbox">
                                                                <label class="custom-checkbox iconallignment">
                                                                    <input ng-reflect-model="false" id="0" class="ng-pristine ng-valid ng-touched" (change)="chekAnalyzeProperty(item)" [(ngModel)]="item.IsChecked" type="checkbox">
                                                                    <i></i>{{item.PropertyName}}
                                                                </label>
                                                                <button *ngIf="!comparePropertiesModel.IsOfferPortfolio" class="delete-property" (click)="deleteAnalyzeProperty(item)"><i class="fa fa-times"></i></button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                      <td  *ngIf="!item.Unpriced" [ngStyle]="{'font-weight' : this.maxCompareValues.MaxAskingPrice==item.AskingPrice ? 'bold' : 'normal'}">{{'$ '+ (item.AskingPrice|number)}}</td>
                                                      <td  *ngIf="item.Unpriced" [ngStyle]="{'font-weight' : this.maxCompareValues.MaxAskingPrice==item.AskingPrice ? 'bold' : 'normal'}">Unpriced</td>
                                                    </tr>
                                                    <tr>
                                                        <td [ngStyle]="{'font-weight' : this.maxCompareValues.MaxNOI==item.NOI ? 'bold' : 'normal'}">{{item.NOI!=null && item.NOI!=0?'$ '+ (item.NOI|number):'-'}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{item.Rating!=null?item.Rating:'-'}}</td>
                                                    </tr>
                                                    <tr>
                                                      <td *ngIf="item.capRateText != 'ZCF'" [ngStyle]="{'font-weight' : this.maxCompareValues.MaxCapRate==item.CapRate ? 'bold' : 'normal'}">{{item.CapRate!=null?item.CapRate + '%':'-'}}</td>
                                                      <td *ngIf="item.capRateText == 'ZCF'" [ngStyle]="{'font-weight' : this.maxCompareValues.MaxCapRate==item.CapRate ? 'bold' : 'normal'}">{{item.capRateText}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td [ngStyle]="{'font-weight' : this.maxCompareValues.MaxReturnDuringPrice==item.ReturnDuringPrice ? 'bold' : 'normal'}">{{item.ReturnDuringPrice!=0?'$ '+ (item.ReturnDuringPrice|number):'-'}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{item.RentEscalations}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td [ngStyle]="{'font-weight' : this.maxCompareValues.MaxRemainingTerm==item.RemainingTerm ? 'bold' : 'normal'}">{{item.RemainingTerm | yearsMonthConverter:true}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td [ngStyle]="{'font-weight' : this.maxCompareValues.MaxBuildingSize==item.BuildingSize ? 'bold' : 'normal'}">{{item.BuildingSize!=0 && item.BuildingSize!=null?(item.BuildingSize|number):'-'}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td [ngStyle]="{'font-weight' : this.maxCompareValues.MaxLand==item.Land ? 'bold' : 'normal'}">{{item.Land!=0 && item.Land!=null?(item.Land|number):'-'}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td [ngStyle]="{'font-weight' : this.maxCompareValues.MaxYearBuilt==item.YearBuilt ? 'bold' : 'normal'}">{{item.YearBuilt}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{item.LeaseStructure}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{item.OwnershipType}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                        <td class="padding0 tdwidth fixedtdlast" *ngIf="!isPropertyAnalysis">
                                            <table class="table ">
                                                <tbody>
                                                    <tr>
                                                        <td style="vertical-align:top" class="firsttd"><p><strong>Total/Avg</strong></p></td>
                                                    </tr>
                                                    <tr>
                                                        <td><p><strong>{{'$ '+ (comparePropertyDataTotalOrAvgModel.AskingPriceTotalOrAvg|number)}}</strong></p></td>
                                                    </tr>
                                                    <tr>
                                                        <td><p><strong>{{'$ '+ (comparePropertyDataTotalOrAvgModel.NOITotalOrAvg|number)}}</strong></p></td>
                                                    </tr>
                                                    <tr>
                                                        <td><p><strong></strong></p></td>
                                                    </tr>
                                                    <tr>
                                                        <td><p><strong>{{comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg!=null?comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg + '% / Avg':'-'}}</strong></p></td>
                                                    </tr>
                                                    <tr>
                                                        <td><p><strong>{{'$ '+(comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal|number)}}</strong></p></td>
                                                    </tr>
                                                    <tr>
                                                        <td><p><strong></strong></p></td>
                                                    </tr>
                                                    <tr>
                                                        <td><p><strong>{{comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg!=0?((comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg | yearsMonthConverter:true) +' / Avg'):'-'}}</strong></p></td>
                                                    </tr>
                                                    <tr>
                                                        <td><p><strong>{{comparePropertyDataTotalOrAvgModel.BuildingSizeTotalOrAvg!=0?(comparePropertyDataTotalOrAvgModel.BuildingSizeTotalOrAvg|number):'-'}}</strong></p></td>
                                                    </tr>
                                                    <tr>
                                                        <td><p><strong>{{comparePropertyDataTotalOrAvgModel.LandTotalOrAvg!=0?(comparePropertyDataTotalOrAvgModel.LandTotalOrAvg|number):'-'}}</strong></p></td>
                                                    </tr>
                                                    <tr>
                                                        <td><p><strong></strong></p></td>
                                                    </tr>
                                                    <tr>
                                                        <td><p><strong></strong></p></td>
                                                    </tr>
                                                    <tr>
                                                        <td><p><strong></strong></p></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="headings clearfix" id="divAnalytics">
                        <h3 class="bleckhead" *ngIf="isAnalyze">Analytics</h3>
                    </div>

                    <div id="capture">
                        <div class="row chartbox-allignment">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
                                <div class="border-div box-height">
                                    <div class="floatinghead clearfix">
                                        <h2 class="mainhead">
                                            <span class="text">Price</span>
                                        </h2>
                                        <div class="col-lg-12">
                                            <h5 *ngIf="!isPropertyAnalysis" class="rightvalue whitespacenowrap">{{'$ '+ (comparePropertyDataTotalOrAvgModel.AskingPriceTotalOrAvg|number)}}</h5>
                                            <div class="ct" id="priceChart"></div>
                                        </div>
                                        </div>
                                    </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
                                <div class="border-div box-height">
                                    <div class="floatinghead clearfix">
                                        <h2 class="mainhead">
                                            <span class="text">NOI</span>
                                        </h2>
                                        <div class="col-lg-12">
                                            <h5 *ngIf="!isPropertyAnalysis" class="rightvalue whitespacenowrap">{{comparePropertyDataTotalOrAvgModel.NOITotalOrAvg!=0?('$ '+ (comparePropertyDataTotalOrAvgModel.NOITotalOrAvg|number)):'-'}}</h5>
                                            <div class="ct" id="NOIChart"></div>
                                        </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div class="row  chartbox-allignment">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
                                <div class="border-div box-height">
                                    <div class="floatinghead clearfix">
                                        <h2 class="mainhead">
                                            <span class="text">Cap Rate</span>
                                        </h2>
                                        <div class="col-lg-12">
                                            <h5 *ngIf="!isPropertyAnalysis" class="rightvalue whitespacenowrap">{{comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg!=0?(comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg+ '% / Avg'):'-'}}</h5>
                                            <div class="ct" id="capRateChart"></div>
                                        </div>
                                        </div>
                                    </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
                                <div class="border-div box-height">
                                    <h2 class="mainhead">
                                        <span class="text">Remaining Term</span>
                                    </h2>
                                    <div class="col-lg-12">
                                        <div class="ct" id="remainingTermChart"></div>
                                        </div>
                                    </div>
                                </div>
                        </div>


                        <div class="row chartbox-allignment">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild" *ngIf="!isPropertyAnalysis">
                                <div class="border-div box-height">
                                    <h2 class="mainhead">
                                        <span class="text">Credit Rating</span>
                                    </h2>
                                    <div class="ct" id="creditRatingChart"></div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild" *ngIf="isPropertyAnalysis">
                                <div class="border-div box-height">
                                    <h2 class="mainhead">
                                        <span class="text">Land Area</span>
                                    </h2>
                                    <div class="col-lg-12">
                                        <div class="ct" id="landAreaChart"></div>
                                        </div>
                                    </div>
                                </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
                                <div class="border-div box-height">
                                    <div class="floatinghead clearfix">
                                        <h2 class="mainhead">
                                            <span class="text">Return During Lease</span>
                                        </h2>
                                        <div class="col-lg-12">
                                            <h5 *ngIf="!isPropertyAnalysis" class="rightvalue whitespacenowrap">{{comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal!=0?('$ '+ (comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal|number)):'-'}}</h5>
                                            <div class="ct" id="returnDuringLeaseChart"></div>
                                        </div>
                                        </div>
                                    </div>
                            </div>

                        </div>
                        <div class="border-div margin0" *ngIf="isAnalyze">
                            <div class="box-height">
                                <div class="floatinghead clearfix">
                                    <h2 class="mainhead">
                                        <span class="text">Projected Revenue - Portfolio</span>
                                    </h2>
                                    <div class="col-lg-12">
                                        <label class="custom-checkbox floatingheadCheckbox margin-right-20" *ngIf="!isPropertyAnalysis">
                                            <input type="checkbox" [(ngModel)]="enableExtendedChart" (change)="bindRevenueChart()">
                                            Total NOI with Options
                                            <i></i>
                                        </label>
                                        <div class="ct" id="revenueChart"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="row" *ngIf="!isAnalyze">

                    <div class="colg-12 col-md-12 col-sm-12 col-xs-12 text-right">
                        <button class="btn btn-lg btn-default margin-bottom-15" (click)="cancelComparison(cancelTemplate,'');">Back</button>
                    </div>
                </div>
                <div class="row" *ngIf="isAnalyze && !comparePropertiesModel.IsOfferPortfolio">
                    <div class="colg-6 col-md-4 col-sm-5 col-xs-12">
                        <button class="btn btn-lg btn-border margin-bottom-15" data-html2canvas-ignore (click)="pdfDownload()">Download as PDF</button>
                    </div>
                    <div class="colg-6 col-md-8 col-sm-7 col-xs-12 text-right" *ngIf="analyzeId==0 && !comparePropertiesModel.IsOfferPortfolio">
                        <button class="btn btn-lg btn-default margin-bottom-15" (click)="cancelComparison(cancelTemplate,'');">cancel</button>
                        <button class="btn btn-lg btn-green margin-bottom-15" (click)="openAnalyzeModal(analysisTemplate,'')">Save</button>
                    </div>
                    <div class="colg-6 col-md-8 col-sm-7 col-xs-12 text-right" *ngIf="analyzeId!=0">
                        <a class="btn btn-lg btn-default margin-bottom-15" (click)="goBack();">Back</a>
                        <!--<button class="btn btn-lg btn-default margin-bottom-15" (click)="cancelComparison(cancelTemplate,'');">cancel</button>-->
                    </div>
                </div>

            </div>
        </div>

        <ng-template #template class="pull-left">

            <div class="modal-header">
                <h4 class="modal-title pull-left">Add Properties</h4>
                <button aria-label="Close" class="close pull-right" (click)="modalRef.hide()" type="button">
                    <span aria-hidden="true">×</span>
                </button>
                <div class="clearfix"></div>
            </div>
            <div class="modal-body">
                <ul class="properties-analyse">
                  <li *ngFor="let item of exchangePropertyList">
                    <label class="custom-checkbox withoutlabel">
                      <input type="checkbox" [(ngModel)]="item.IsChecked" (change)="onAddPropertyChecked(item);"><i></i>
                    </label>
                    <label class="property-name" *ngIf="!haveaccesstoviewlocation">
                      {{item.PropertyName}} - {{item.ConfidentialLocation ? 'Confidential' : (item.City +' ,')}}  {{item.ConfidentialLocation ? '':item.State}}
                      <span class="placeoffer"><p [ngClass]="{'favoritelabel':(item.Title === 'Favorites'),'suggestedlabel':item.Title === 'Suggested','pendinglabel':item.Title === 'Pending Offer','offeracceptedlabel':item.Title === 'Offer Accepted','undercontractlabel':item.Title === 'Under Contract','hardcontractlabel':item.Title === 'Hard Contract','closeddealslabel':item.Title === 'Closed'}">{{item.Title}}</p></span>
                    </label>
                    <label class="property-name" *ngIf="haveaccesstoviewlocation">
                      {{item.PropertyName}} - {{item.City}} , {{item.State}}
                      <span class="placeoffer"><p [ngClass]="{'favoritelabel':(item.Title === 'Favorites'),'suggestedlabel':item.Title === 'Suggested','pendinglabel':item.Title === 'Pending Offer','offeracceptedlabel':item.Title === 'Offer Accepted','undercontractlabel':item.Title === 'Under Contract','hardcontractlabel':item.Title === 'Hard Contract','closeddealslabel':item.Title === 'Closed'}">{{item.Title}}</p></span>
                    </label>
                    <h6 class="itemprice">
                      <span *ngIf="!item.Unpriced">  {{'$ '+ (item.Price|number)}} </span>
                      <span *ngIf="item.Unpriced"> Unpriced </span>
                    </h6>
                    <ul class="listing clearfix">
                      <li>
                        <h5>CAP</h5>
                        <h6 *ngIf="item.CharacteristicsId == 1">ZCF</h6>

                        <h6 *ngIf="item.CharacteristicsId != 1">{{item.CapRate!=null && item.CapRate!=0 ?((item.CapRate)+'%'):'-'}}</h6>
                      </li>
                      <li>
                        <h5>Rating</h5>
                        <h6>{{item.Rating!=null && item.Rating!=undefined ?(item.Rating):'-'}}</h6>
                      </li>
                      <li>
                        <h5>NOI</h5>
                        <h6>{{item.NOI!=null && item.NOI!=0 ?'$ '+ (item.NOI|number):'-'}}</h6>
                      </li>
                      <li>
                        <h5>Term</h5>
                        <h6>{{item.Term | yearsMonthConverter:true}}</h6>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div class="text-right margin-top-20">
                    <button class="btn btn-default btn-lg" (click)="modalRef.hide()">Cancel</button>
                    <button class="btn btn-success btn-lg" (click)="addPropertyInComparisonList()">Add</button>
                </div>
            </div>
        </ng-template>

        <ng-template #cancelTemplate>
            <div class="modal-header">
                <h4 class="modal-title pull-left">Exit</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body padding30">

                <div class="form-group">
                    <h6 class="displayvalue">Are you sure you want to cancel ?</h6>
                </div>
                <div class="text-right">
                    <button class="btn btn-lg btn-default" (click)="modalRef.hide()">No</button>
                    <a href="javascript:void(0);" class="btn btn-lg btn-success" (click)="cancelSuccess()">Yes</a>
                </div>
            </div>
        </ng-template>

        <ng-template #analysisTemplate>
            <div class="modal-header">
                <h4 class="modal-title pull-left">Save Analysis</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body padding30">

                <div class="form-group">
                    <label class="form-label">Analysis Name<span class="red">*</span></label>
                    <input class="form-control" [(ngModel)]="comparePropertiesModel.Name" type="text" maxlength="100">
                    <p class="redtext" *ngIf="isAnalyzeName">Analysis Name is required </p>
                </div>
                <div class="text-right">
                    <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Exit</button>
                    <button class="btn btn-lg btn-success" [disabled]="isSaveDisabled" (click)="saveAnalyze()">Save</button>
                </div>
            </div>

        </ng-template>
